const SocialMediaShareButtons = (container, url) => {

    if(!container)
        return;
    
    if(!url)
        url = window.location.href;

    const copyLink = function (e) {
        console.log('copy link');
        e.preventDefault();
        $(this).toggleClass('selected');
        $(this).parent().find(".some-share__url-copy-area").toggleClass('d-none');
        $(this).parent().find('.some-share__url-input').select();
    };

    const element = $(container);

    if (element.length && typeof Liferay !== 'undefined') {

        let locale = Liferay.ThemeDisplay.getLanguageId();

        let header, facebook, twitter, copy, clipboard;

        switch (locale) {
            case 'sv_SE':
                header = "Dela:";
                facebook = "Dela - Facebook";
                twitter = "Dela - Twitter";
                copy = "Kopiera adressen";
                clipboard = "Kopiera länken till klippbordet";
                break;
            case 'en_US':
                header = "Share:";
                facebook = "Share - Facebook";
                twitter = "Share - Twitter";
                copy = "Copy an address";
                clipboard = "Copy to the clipboard";
                break;
            case 'de_DE':
                header = "Teilen:";
                facebook = "Teilen - Facebook";
                twitter = "Teilen - Twitter";
                copy = "Adresse kopieren";
                clipboard = "In die Zwischenablage kopieren";
                break;
            case 'sms_FI':
                header = "Jueʹjj:";
                facebook = "Jueʹjj - Facebook";
                twitter = "Jueʹjj - Twitter";
                copy = "Kopiââʹst";
                clipboard = "Kopioi linkki leikepöydälle";
                break;
            case 'smn_FI':
                header = "Jyevi:";
                facebook = "Jyevi - Facebook";
                twitter = "Jyevi - Twitter";
                copy = "Kopijist čujottâs";
                clipboard = "Kopijist liiŋkâ čuopâspiävdán";
                break;
            case 'sme_FI':
                header = "Juoge:";
                facebook = "Juoge - Facebook";
                twitter = "Juoge - Twitter";
                copy = "Kopiere čujuhusa";
                clipboard = "Kopiere liŋkka čuohpusbeavdái";
                break;
            default:
                header = "Jaa:";
                facebook = "Jaa - Facebook";
                twitter = "Jaa - Twitter";
                copy = "Kopioi osoite";
                clipboard = "Kopioi linkki leikepöydälle";
        }



        const template = `
            <div class="some-share">
                <span class="some-share__title">${header}</span>
                <a href="javascript:window.open('http://www.facebook.com/sharer.php?u=${url}','','width=550,height=266');void(0)" 
                    class="some-share__button some-share__facebook" title="${facebook}">
                    <span class="sr-only">${facebook}</span>
                    <i class="fab fa-facebook-f" aria-hidden="true"></i>
                </a>
                <a class="share-icon some-share__button some-share__twitter" title="${twitter}"
                    href="https://twitter.com/intent/tweet?url=${url}">
                    <span class="sr-only">${twitter}</span>
                    <i class="fab fa-x-twitter" aria-hidden="true"></i>
                </a>
                <a href="#" class="share-icon some-share__button some-share__copy-url" title="${copy}">
                    <i class="fas fa-link"></i>
                    <span class="sr-only">${copy}</span>    
                </a>
                <div id="some-share__url-copy-area" class="some-share__url-copy-area d-none">
                    <p>${clipboard}</p>
                    <input class="some-share__url-input form-control" type="text" value="${url}"/>
                </div>
            </div>
        `;

        element.html(template);

        $(document).on('click', '.some-share__copy-url', copyLink);
    }
};

export default SocialMediaShareButtons;